import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    TypographyStylesProvider,
    Text,
    Badge,
} from '@mantine/core';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
  IconBell,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
} from '@tabler/icons';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    cardContent: {
        justifyContent: 'center',
        margin: '0 auto',
        textAlign: 'center'
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    subItem: {
        margin: '0 auto',
        maxWidth: '800px'
    }
}));


//needed: pass params to fill out the areas of the alert item
//export function SubscribersItem {
const SubscribersItem = ({avatar, username, status}) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    const component_md = {
        par: 'subscribers',
        lvl: 0,
        child: 'all',
        mode: 0,
        section: 'allSection',
    }



    return (
        <>
            <Card shadow="sm" padding="lg" radius="md" withBorder className={classes.subItem}>
                <Avatar src={avatar} size={120} radius={120} mx="auto"/>
                <Text ta="center" td="underline" c="blue" fz="xl">{`@${username}`}</Text>
                <br/>
                <Badge fz="lg" ta="center" color="green" fullWidth>
                    {status}
                </Badge>
            </Card>
        </>
    );
    
}
export default SubscribersItem
